module.exports = __webpack_public_path__ + "img/sadness.03bec26e.svg";